import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _Agency, _AirLine, _Airport, _CommercialCampaign, _CustomerAddress, _ImportAgency } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectSiteID } from "../../../admin/configuracion/SiteID/SelectSiteID";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { MarketPlaceEditor } from "../MarketPlace/MarketPlaceEditor";
import { CompanyEditor } from "../../../erp/cellEditor/Company/CompanyEditor";
import { OfficeEditor } from "../../../erp/cellEditor/Office/OfficeEditor";
import { AirportEditor } from "../Airport/AirportEditor";
import { FileInput } from "../../../theme/Component/FileInput";
import { CitiesEditor } from "../Countries/Cities/CitiesEditor";
import { AgencyRole } from "./AgencyRole/AgencyRole";


export const Agency = () => {

    const agency = useDataBean(_Agency);
    const impagency = useDataBean(_ImportAgency);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalrol, setModalrol] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaladd, setModaladd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        agency.instance.getAgencyCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Client = (user.DataBeanProperties.AccountNit ?? "") + "-" + (user.DataBeanProperties.AccountName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const importAgencyCatalog = () => {
        //console.log(entailment.bean);
        impagency.instance.importAgencyCatalog(impagency.bean.Media, impagency.bean.MediaContext, null).then(
            (resp: any) => {
                getLista();
                setModaladd({ ...modaladd, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        agency.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        agency.instance.deleteAgency(agency.bean.IDAgency).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        agency.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const veradd = () => {
        setModaladd({ ...modaladd, "view": true });

    }

    const head = [
        { title: 'ID', property: 'IDAgency', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Teléfono (1)', property: 'Tel1', visible: true },
        { title: 'Teléfono (2)', property: 'Tel2', visible: true },
        { title: 'Fax', property: 'Fax', visible: true },
        { title: 'Número Celular (1)', property: 'CellNumber1', visible: true },
        { title: 'Número Celular (2)', property: 'CellNumber2', visible: true },
        { title: 'Dirección', property: 'Address', visible: true },
        { title: 'Correo Electrónico', property: 'eMail', visible: true },
        { title: 'URL Sitio Web', property: 'WebSiteUrl', visible: true },
        { title: 'Aeropuerto', property: 'AirportName', visible: true },
        { title: 'Lector de Barras', property: 'BarCodeReader', visible: true },
        { title: 'Impresora de Etiquetas', property: 'StickerPrinter', visible: true },
        { title: 'Impresión de Guías de Transporte', property: 'GuidePrinter', visible: true },
        { title: 'Código Agencia', property: 'Code', visible: true },
        { title: 'Habilitado', property: 'Enabled', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Ciudad', property: 'SiteIDName', visible: true },
        { title: 'Tercerizada', property: 'Outsourced', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
        { title: 'Habilitada', property: 'Enabled', visible: true },
        { title: 'MarketPlace', property: 'MarketPlaceName', visible: true },
        { title: 'Empresa', property: 'CompanyName', visible: true },
        { title: 'Oficina', property: 'OfficeName', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Roles de la Agencia', icono: 'ri-shield-user-fill', visible: single.canEdit(), evento: () => { setModalrol({ ...modalrol, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Agencias">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={veradd}>
                        Importar Agencias
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={agency.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={agency.bean.Name} onChange={agency.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Teléfono (1)</label>
                                <input type="text" name="Tel1" className="form-control" value={agency.bean.Tel1} onChange={agency.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Teléfono (2)</label>
                                <input type="text" name="Tel2" className="form-control" value={agency.bean.Tel2} onChange={agency.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Fax</label>
                                <input type="text" name="Fax" className="form-control" value={agency.bean.Fax} onChange={agency.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Número Celular (1)</label>
                                <input type="text" name="CellNumber1" className="form-control" value={agency.bean.CellNumber1} onChange={agency.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Número Celular (2)</label>
                                <input type="text" name="CellNumber2" className="form-control" value={agency.bean.CellNumber2} onChange={agency.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Dirección</label>
                                <input type="text" name="Address" className="form-control" value={agency.bean.Address} onChange={agency.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Correo Electrónico</label>
                                <input type="text" name="eMail" className="form-control" value={agency.bean.eMail} onChange={agency.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>URL Sitio Web</label>
                                <input type="text" name="WebSiteUrl" className="form-control" value={agency.bean.WebSiteUrl} onChange={agency.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <CitiesEditor render={agency.bean.SiteIDName} idSelector={agency.bean.IDCities} onChange={(e) => { agency.setBean({ ...agency.bean, "IDCities": e.IDCities, "SiteIDName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <AirportEditor render={agency.bean.AirportName} idSelector={agency.bean.IDAirport} onChange={(e) => { agency.setBean({ ...agency.bean, "IDAirport": e.IDAirport, "AirportName": e.Name }) }} returnType="Object" />

                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Lector de Barras" estado={agency.bean.BarCodeReader} eventChange={(e: any) => { agency.setBean({ ...agency.bean, "BarCodeReader": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Impresora de Etiquetas" estado={agency.bean.StickerPrinter} eventChange={(e: any) => { agency.setBean({ ...agency.bean, "StickerPrinter": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Impresión de Guías de Transporte" estado={agency.bean.GuidePrinter} eventChange={(e: any) => { agency.setBean({ ...agency.bean, "GuidePrinter": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <label>Código Agencia</label>
                                <input type="text" name="Code" className="form-control" value={agency.bean.Code} onChange={(e: any) => { agency.setBean({ ...agency.bean, "Code": e }) }} />
                            </div>
                            {/* <div className="col-md-6">
                                <BasicSwitch label="Habilitado" estado={agency.bean.Enabled} eventChange={(e: any) => { agency.setBean({ ...agency.bean, "Enabled": e }) }}></BasicSwitch>
                            </div> */}
                            {/* <div className="col-md-6">
                                <SelectSiteID edit idLnSite={agency.bean.IDLnSiteID} label="Ubicación Geográfica" onChange={(e) => { agency.setBean({ ...agency.bean, "IDLnSiteID": e.IDLn }) }} />
                            </div> */}
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Tercerizada" estado={agency.bean.Outsourced} eventChange={(e: any) => { agency.setBean({ ...agency.bean, "Outsourced": e }) }}></BasicSwitch>
                            </div>
                            {agency.bean.Outsourced && <>

                                <div className="col-md-6">
                                    <AccountEditor label="Tercero" idAccount={agency.bean.IDAccount} onChange={(e) => { agency.setBean({ ...agency.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>
                            </>}
                            <div className="col-md-6">
                                <MarketPlaceEditor idSelector={agency.bean.IDMarketPlace} onChange={(e) => { agency.setBean({ ...agency.bean, "IDMarketPlace": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <CompanyEditor id={agency.bean.IDCompany} onchange={(e) => { agency.setBean({ ...agency.bean, "IDCompany": e }) }} />
                            </div>
                            {agency.bean.IDCompany && <>
                                <div className="col-md-6">
                                    <OfficeEditor label="Ciudad" id={agency.bean.IDOffice} idconpany={agency.bean.IDCompany} onchange={(e) => { agency.setBean({ ...agency.bean, "IDOffice": e }) }} />
                                </div>
                            </>}
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Habilitada" estado={agency.bean.Enabled} eventChange={(e: any) => { agency.setBean({ ...agency.bean, "Enabled": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={agency.bean.Description} onChange={agency.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modaladd} updateModal={setModaladd} eventModal={importAgencyCatalog}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <FileInput
                                        Media={impagency.bean.Media}
                                        MediaContext={impagency.bean.MediaContext}
                                        directory='Agency'
                                        label='Archivo'
                                        docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                        onCreate={(Filemap: any) => { impagency.setBean({ ...impagency.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                    ></FileInput>
                                </div>
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalrol} updateModal={setModalrol}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <AgencyRole idAgency={agency.bean.IDAgency} />
                                </div>
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {agency.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}